import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "4a3194d6-8e4a-4a04-8f1a-e091b501bca8", content: "Strength G", options: {} },
  { id: "4f99373a-143d-4ae4-bc5a-8cb7ed376c33", content: "Early decay time EDT", options: {} },
  { id: "04c83427-c5dc-4a49-a7f5-961d499c4538", content: "Centre time T<sub>s</sub>", options: {} },
  { id: "cf17d454-9961-433d-9aa9-c843ef48bbc9", content: "Late lateral sound level L<sub>j</sub>", options: {} },
  { id: "4a52f025-4a6f-4253-9bca-77ace317a8ec", content: "Definition D<sub>50</sub>", options: {} },
  { id: "7de79123-1347-4caf-9ee1-77f696d01033", content: "Initial time delay gap ITDG", options: {} },
  { id: "078c9727-f57e-456c-b254-0e19a664364f", content: "Music clarity C<sub>80</sub>", options: {} },
  { id: "7e742759-1cfd-41c7-b9e1-10524ef6fa9c", content: "Early lateral energy fraction J<sub>LF</sub>", options: {} },
  { id: "bb88edf1-bd7b-4184-b6fa-de45091979aa", content: "Reverberation time RT<sub>60</sub>", options: {} },
  { id: "10a052f3a-d043-4e29-8f6f-b94c0a928a8d", content: "Speech clarity C<sub>50</sub>", options: {} },
];

const groups = [
  { id: "cff39586-8ddb-40f6-84d8-ff6746601eb0", content: "Clarity", options: {} },
  { id: "072b896f-c526-45a5-a61d-3349b6565cab", content: "Reverberation", options: {} },
  { id: "2bb64eb2-96a0-4c57-b51c-65f27a9ad125", content: "Impression of space", options: {} },
  { id: "d1a3e7aa-35da-4080-aba6-2d86cee6030c", content: "Intimacy", options: {} },
  { id: "79ccae35-d21c-48e7-a72c-fbd351833466", content: "Loudness", options: {} },
];

export const task: Task = {
  id: "33965f5e-c200-446b-8631-3c8c5053c6ce",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    orientation: "horizontal",
    shuffle: false,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "cff39586-8ddb-40f6-84d8-ff6746601eb0",
      itemsId: [
        "04c83427-c5dc-4a49-a7f5-961d499c4538",
        "4a52f025-4a6f-4253-9bca-77ace317a8ec",
        "078c9727-f57e-456c-b254-0e19a664364f",
        "10a052f3a-d043-4e29-8f6f-b94c0a928a8d",
      ],
    },
    {
      groupId: "072b896f-c526-45a5-a61d-3349b6565cab",
      itemsId: ["4f99373a-143d-4ae4-bc5a-8cb7ed376c33", "bb88edf1-bd7b-4184-b6fa-de45091979aa"],
    },
    {
      groupId: "2bb64eb2-96a0-4c57-b51c-65f27a9ad125",
      itemsId: ["cf17d454-9961-433d-9aa9-c843ef48bbc9", "7e742759-1cfd-41c7-b9e1-10524ef6fa9c"],
    },
    {
      groupId: "d1a3e7aa-35da-4080-aba6-2d86cee6030c",
      itemsId: ["7de79123-1347-4caf-9ee1-77f696d01033"],
    },
    {
      groupId: "79ccae35-d21c-48e7-a72c-fbd351833466",
      itemsId: ["4a3194d6-8e4a-4a04-8f1a-e091b501bca8"],
    },
  ],
};
